import React, { useEffect, useState } from 'react';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../../url';
import './TiendaInfoCard.css';

export default function TiendaInfoCard() {
    const [tienda, setTienda] = useState(null);

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const tiendaPrincipal = data.tienda?.[0];
                if (tiendaPrincipal) {
                    setTienda(tiendaPrincipal);
                }
            })
            .catch(error => console.error('Error al cargar tienda:', error));
    };

    if (!tienda) {
        return (
            <div className="tiendaInfoCard tiendaInfoCard--empty">
                <div className="tiendaInfoCard__avatar">
                    <span></span>
                </div>
                <Anchor to="contacto" className="tiendaInfoCard__btn">
                    Configurar
                </Anchor>
            </div>
        );
    }

    return (
        <Anchor to="contacto" className="tiendaInfoCard">
            <div className="tiendaInfoCard__avatar">
                {tienda.imagen1 ? (
                    <img src={tienda.imagen1} alt={tienda.nombre} />
                ) : (
                    <span>{tienda.nombre?.charAt(0)}</span>
                )}
            </div>
            <h3 className="tiendaInfoCard__nombre">{tienda.nombre}</h3>
            {tienda.eslogan && (
                <p className="tiendaInfoCard__eslogan">{tienda.eslogan}</p>
            )}
        </Anchor>
    );
}